/* eslint-disable no-loop-func */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { ChangeEvent, Fragment, useCallback, useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { Footer, FooterButton, FormBlock, FormGroup, Wrapper } from '../../components/admin-page/admin-page.styles';
import { Form, Formik, Field } from 'formik';
import { ArrowDown, GoUp, Save } from '../../assets/icons';
import { checkVal, currentYear, getBudgetTotals, getLang, handleGoUp, isRegion, OBLAST_KATO, t, updateKatoAccessList } from '../../utils/helpers.utils';
import { toast, ToastContainer } from 'react-toastify';
import { getGeneralInfo } from '../../requests/snp.request';
import { IBudgetItem } from '../../interfaces/snp.interface';
import { updateFormPartial } from '../../requests/supervisor.request';
import { months } from '../../components/right-menu/psd-tabs/all-psd-tab.component';

const alteredMonths = {
  ru: months['ru'],
  kz: ['қаңтарға', 'ақпанға', 'наурызға', 'сәуірге', 'мамырға', 'маусымға', 'шілдеге', 'тамызға', 'қыркүйекке', 'қазанға', 'қарашаға', 'желтоқсанға']
}

const BudgetPage = () => {
  const { i18n: { language } } = useTranslation();
  const navigate = useNavigate();
  const { kato } = useParams();

  const formikRef = useRef<any>(null);
  const wrapperRef = useRef<any>(null);

  const [regions, setRegions] = useState<any[]>([]);
  const [snps, setSnps] = useState<any[]>([]);
  const [region, setRegion] = useState<number>(0);
  const [snp, setSnp] = useState<number>(0);
  const [katoAccessList, setKatoAccessList] = useState<number[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isKatoRegion, setIsKatoRegion] = useState(false);
  const [errors, setErrors] = useState<any>({});
  const [budgetStats, setBudgetStats] = useState<IBudgetItem>({
    budgetProcessing: 0,
    curBudgetAnnualPlan: 0,
    curBudgetMonthlyFact: 0,
    curBudgetMonthlyPlan: 0,
    devBudgetAnnualPlan: 0,
    devBudgetMonthlyFact: 0,
    devBudgetMonthlyPlan: 0,
    totalBudgetAnnualPlan: 0,
    totalBudgetMonthlyFact: 0,
    totalBudgetMonthlyPlan: 0,
    curBudgetMonthlyProcessing: 0,
    curBudgetAnnualProcessing: 0,
    devBudgetMonthlyProcessing: 0,
    devBudgetAnnualProcessing: 0,
    totalBudgetMonthlyProcessing: 0,
    totalBudgetAnnualProcessing: 0,
    totalProjectCount: 0
  });
  const [isOpen, setIsOpen] = useState({
    cur: false,
    dev: false,
    total: false
  });

  const validateForm = (data: any) => {
    setErrors({});
    let res = true;
    // SECTION NINE
    const budgetData: any = budgetStats;
    const keys = ['curBudgetMonthlyPlan', 'curBudgetMonthlyFact', 'curBudgetAnnualPlan', 'devBudgetMonthlyPlan', 'devBudgetMonthlyFact', 'devBudgetAnnualPlan']
    if (keys.some(key => checkVal(budgetData[key]) && +budgetData[key] !== 0)) {
      for (const key of keys) {
        if (!checkVal(budgetData[key]) || +budgetData[key] === 0) {
          setErrors((prev: any) => ({ ...prev, [`budgetStats.${key}`]: true }))
          toast.error(t(`errors.streetName`, language));
          return false;
        }
      }
    }

    return res;
  }

  const handleSubmitForm = (values: any) => {
    setErrors({});

    const data = {
      budgetStats,
    }

    if (kato && validateForm(data)) {
      updateFormPartial(kato, data)
        .then(() => {
          toast.success(t('toast.save_success'))
          loadForm();
        })
        .catch(() => toast.error('Ошибка при сохранении'));
    }
  }

  const handleRegionChange = (e: ChangeEvent<HTMLSelectElement>) => {
    setRegion(+e.target.value);
    setSnps(regions.find((item) => +item.value === +e.target.value)?.children || []);
    kato && isRegion(+kato) && navigate(`/admin/${e.target.value}/budget`)
  }

  const handleSnpChange = (e: ChangeEvent<HTMLSelectElement>) => {
    setSnp(+e.target.value)
    navigate(`/admin/${e.target.value}`)
  }
  const loadForm = useCallback(() => {
    const val = kato ? kato : snp
    val && getGeneralInfo(+val).then((res: any) => {
      setBudgetStats(res.budgetStats);
      setIsLoading(false);
    });

  }, [region, snp, kato])

  const renderSelects = (lang: 'Ru' | 'Kz' = 'Ru') => {
    return (
      kato && +kato !== OBLAST_KATO && <div className="grid-item">
        <FormGroup>
          <label htmlFor="region">{t(`form.region.name`, lang)}</label>
          <Field as="select" value={region} onChange={handleRegionChange} disabled={lang.toLowerCase() !== language}>
            {regions.map((item) => <option key={item.value} value={item.value}>{lang === 'Kz' ? item.labelKz : item.label}</option>)}
          </Field>
        </FormGroup>

        {!isKatoRegion && <FormGroup>
          <label htmlFor="snp">{t(`form.snp.name`, lang)}</label>
          <Field as="select" value={snp} onChange={handleSnpChange} disabled={lang.toLowerCase() !== language}>
            {snps.map((item) => <option key={item.value} value={item.value}>{lang === 'Kz' ? item.labelKz : item.label}</option>)}
          </Field>
        </FormGroup>}
      </div>
    )
  }

  const renderFields = (lang: 'Ru' | 'Kz', setFieldValue: any) => {
    return <div className="grid-item">
      {
        budgetStats && <FormBlock id="budget" type='white'>
          <div className="title bold">
            {t('budget.title', lang)}, {kato && isRegion(+kato) ? 'млн. ' : 'тыс. '} {t('form.tenge', lang)}
          </div>

          <FormBlock type='white'>
            <div className="title bold c-pointer" onClick={() => setIsOpen({ ...isOpen, cur: !isOpen.cur })}>
              {t('budget.currentProjects', lang)}
              {
                isOpen['cur']
                  ? <ArrowDown width={10} style={{ transform: 'rotate(180deg)' }} />
                  : <ArrowDown width={10} />
              }
            </div>

            {
              isOpen['cur'] && <>
                {
                  ['curBudgetMonthlyPlan', 'curBudgetMonthlyFact', 'curBudgetAnnualPlan'].map((key: string, index: number) => (
                    <FormGroup key={key}>
                      <label htmlFor={`budgetStats.${key}`}>
                        {key.includes('Annual') ? t(`budget.${key}`, lang).replace('&year', currentYear) : t(`budget.${key}`, lang).replace('&date', `1 ${months[lang.toLowerCase() as 'ru' | 'kz'][new Date().getMonth()]}`)}
                      </label>
                      <Field
                        name={`budgetStats.${key}`}
                        type="number"
                        as="input"
                        className={`${errors[`budgetStats.${key}`] ? 'error' : ''}`}
                        onChange={(e: any) => {
                          const val = e.target.value;
                          setFieldValue(`budgetStats.${key}`, val);
                          setBudgetStats({
                            ...budgetStats,
                            [key]: val
                          })
                        }}
                        value={budgetStats[key as keyof IBudgetItem] || ''}
                      />
                    </FormGroup>
                  ))
                }
                {
                  ['curBudgetMonthlyProcessing', 'curBudgetAnnualProcessing'].map((key: string, index: number) => (
                    <FormGroup key={key}>
                      <label htmlFor={`budgetStats.${key}`}>
                        {key.includes('Annual') ? t(`budget.${key}`, lang).replace('&year', currentYear) : t(`budget.${key}`, lang).replace('&date', `1 ${months[lang.toLowerCase() as 'ru' | 'kz'][new Date().getMonth()]}`)}
                      </label>
                      <Field
                        name={`budgetStats.${key}`}
                        type="number"
                        as="input"
                        disabled
                        value={getBudgetTotals(budgetStats, key as keyof IBudgetItem) || ''}
                      />
                    </FormGroup>
                  ))
                }
              </>
            }

          </FormBlock>

          <FormBlock type='white'>
            <div className="title bold c-pointer" onClick={() => setIsOpen({ ...isOpen, dev: !isOpen.dev })}>
              {t('budget.devProjects', lang)}
              {
                isOpen['dev']
                  ? <ArrowDown width={10} style={{ transform: 'rotate(180deg)' }} />
                  : <ArrowDown width={10} />
              }
            </div>

            {
              isOpen['dev'] && <>
                {
                  ['devBudgetMonthlyPlan', 'devBudgetMonthlyFact', 'devBudgetAnnualPlan'].map((key: string, index: number) => (
                    <FormGroup key={key}>
                      <label htmlFor={`budgetStats.${key}`}>
                        {key.includes('Annual') ? t(`budget.${key}`, lang).replace('&year', currentYear) : t(`budget.${key}`, lang).replace('&date', `1 ${months[lang.toLowerCase() as 'ru' | 'kz'][new Date().getMonth()]}`)}
                      </label>
                      <Field
                        name={`budgetStats.${key}`}
                        type="number"
                        as="input"
                        className={`${errors[`budgetStats.${key}`] ? 'error' : ''}`}
                        onChange={(e: any) => {
                          const val = e.target.value;
                          setFieldValue(`budgetStats.${key}`, val);
                          setBudgetStats({
                            ...budgetStats,
                            [key]: val
                          })
                        }}
                        value={budgetStats[key as keyof IBudgetItem] || ''}
                      />
                    </FormGroup>
                  ))
                }
                {
                  ['devBudgetMonthlyProcessing', 'devBudgetAnnualProcessing'].map((key: string, index: number) => (
                    <FormGroup key={key}>
                      <label htmlFor={`budgetStats.${key}`}>
                        {key.includes('Annual') ? t(`budget.${key}`, lang).replace('&year', currentYear) : t(`budget.${key}`, lang).replace('&date', `1 ${months[lang.toLowerCase() as 'ru' | 'kz'][new Date().getMonth()]}`)}
                      </label>
                      <Field
                        name={`budgetStats.${key}`}
                        type="number"
                        as="input"
                        disabled
                        value={getBudgetTotals(budgetStats, key as keyof IBudgetItem) || ''}
                      />
                    </FormGroup>
                  ))
                }
              </>
            }

          </FormBlock>

          <FormBlock type='white'>
            <div className="title bold c-pointer" onClick={() => setIsOpen({ ...isOpen, total: !isOpen.total })}>
              {t('budget.total', lang)}
              {
                isOpen['total']
                  ? <ArrowDown width={10} style={{ transform: 'rotate(180deg)' }} />
                  : <ArrowDown width={10} />
              }
            </div>

            {
              isOpen['total'] && ['totalBudgetAnnualPlan', 'totalBudgetMonthlyPlan', 'totalBudgetMonthlyFact', 'totalBudgetMonthlyProcessing', 'totalBudgetAnnualProcessing'].map((key: string, index: number) => (
                <FormGroup key={key}>
                  <label htmlFor={`budgetStats.${key}`}>
                    {key.includes('Annual') ? t(`budget.${key}`, lang).replace('&year', currentYear) : t(`budget.${key}`, lang).replace('&date', `1 ${alteredMonths[lang.toLowerCase() as 'ru' | 'kz'][new Date().getMonth()]}`)}
                  </label>
                  <Field
                    name={`budgetStats.${key}`}
                    type="number"
                    as="input"
                    disabled
                    value={getBudgetTotals(budgetStats, key as keyof IBudgetItem) || ''}
                  />
                </FormGroup>
              ))
            }
          </FormBlock>
        </FormBlock>
      }
    </div>
  }

  useEffect(() => {
    loadForm();
  }, [loadForm, snp]);

  useEffect(() => {
    kato && updateKatoAccessList(katoAccessList, kato, navigate, setRegions, setRegion, setSnps, setSnp);
  }, [katoAccessList, kato]);

  useEffect(() => {
    if (kato) {
      setIsKatoRegion(isRegion(+kato))
    }
  }, [kato])

  useEffect(() => {
    const item = localStorage.getItem('user');
    if (item) {
      const snpInfo = JSON.parse(item);
      if (snpInfo && snpInfo.kato_access) {
        setKatoAccessList(snpInfo.kato_access)
      }
    }
  }, [])

  return (
    <div style={{ position: 'relative' }}>
      {
        !isLoading && <>
          <Wrapper ref={wrapperRef}>
            <Formik
              initialValues={{}}
              onSubmit={(values) => {
                handleSubmitForm(values);;
              }}
              innerRef={formikRef}
            >
              {({ setFieldValue }) => (
                <Form>
                  {renderSelects(getLang())}
                  {renderSelects(getLang() !== 'Kz' ? 'Kz' : 'Ru')}
                  {renderFields(getLang(), setFieldValue)}
                  {renderFields(getLang() !== 'Kz' ? 'Kz' : 'Ru', setFieldValue)}
                  <Footer>
                    <div className="buttons">
                      <FooterButton variant="save"><Save /> {t('save', language)}</FooterButton>
                    </div>
                    <div className="buttons">
                      <FooterButton variant="go-up" type='button' onClick={() => handleGoUp(wrapperRef)}><GoUp /> {t('go-up', language)}</FooterButton>
                    </div>
                  </Footer>
                </Form>
              )}
            </Formik>
          </Wrapper>
        </>
      }
      <ToastContainer />
    </div>
  )
}

export default BudgetPage